export const IGNORE_PARAMS_FILTERS = [
  "category",
  "s",
  "page",
  "view",
  "sortBy",
  "sortByDesc"
];

export const IGNORE_PARAMS_FILTERS_ON_CATEGORY_TOGGLE = [
  "category",
  "s",
  "page",
  "sortBy",
  "sortByDesc"
];
